<div class="container">
  <div class="mt-6 font-weight-bold text-center">
    <h5>{{'OVERVIEW.SEARCH_DEFINITIVE_ORDERS' | translate}}</h5>
  </div>
  <div class="text-center size-14">
    <div>{{'OVERVIEW.VIEW_ALL_ORDERSS_SEARCH' | translate}}</div>
  </div>
  <app-all-orders [view]="view" (toggleView)="toggleView($event)"></app-all-orders>
  <app-order-options *ngIf="isOptionOrders"></app-order-options>
</div>

<app-snack-bar
  [showSnackBarInput]="showSnackBar"
  [snackBarSuccessInput]="snackBarSuccess"
  [snackBarMessageInput]="snackBarMessage"
  (showSnackBarOutput)="handleShowSnackBar($event)"
></app-snack-bar>

<ng-template #chooseAffiliateModal>
  <app-affiliate-selection-modal (hideModal)="modalRef.hide()"></app-affiliate-selection-modal>
</ng-template>
